// extracted by mini-css-extract-plugin
export default {"Page":"CreateAccount_Page__k0caI","CreateAccountBlock":"CreateAccount_CreateAccountBlock__a-v6b"};